import React, { FC } from 'react'
import styles from './HeaderSearch.module.scss'
import useSearchProvider from 'components/SA/SearchProvider/hooks/useSearchProvider'
import { SearchOptionLinksObject } from 'types/SearchProvider'
import SearchOptionLinks from './components/SearchOptionLinks'
import PopularSearches from './components/PopularSearches'
import SearchMenuContentSkeleton from './SearchMenuContentSkeleton'

type SearchMenuContentProps = {
  suggestions: ReadonlyArray<SearchOptionLinksObject>
  recentSearches: ReadonlyArray<SearchOptionLinksObject>
  popularSearches: ReadonlyArray<SearchOptionLinksObject>
  setIsFocused: (isFocused: boolean) => void
  onRecentSearchRemove: (label: string) => void
  onSearch: (query: string) => void
  matchedTerm?: string
  isExpanding?: boolean
}

const SearchMenuContent: FC<SearchMenuContentProps> = ({
  suggestions,
  recentSearches,
  popularSearches,
  setIsFocused,
  onRecentSearchRemove,
  onSearch,
  matchedTerm,
  isExpanding = false,
}) => {
  const { getSearchProviderAttributes } = useSearchProvider()

  return (
    <div
      className={styles.searchDropdownBox}
      {...getSearchProviderAttributes([{ 'autocomplete-container': true }])}
    >
      {isExpanding ? (
        <SearchMenuContentSkeleton />
      ) : (
        <>
          <SearchOptionLinks
            title='Suggestions'
            options={suggestions}
            setIsFocused={setIsFocused}
            onSearch={onSearch}
            matchedTerm={matchedTerm}
            highlightMatchedTerms={true}
            sectionName='Search Suggestions'
          />
          <SearchOptionLinks
            title='Recent Searches'
            options={recentSearches}
            setIsFocused={setIsFocused}
            onRemove={onRecentSearchRemove}
            onSearch={onSearch}
            icon='recent-search'
          />
          <PopularSearches
            popularSearches={popularSearches}
            setIsFocused={setIsFocused}
            onSearch={onSearch}
          />
        </>
      )}
    </div>
  )
}

export default SearchMenuContent
